const browserLocation = {
  reload(forceReload) {
    global.location.reload(forceReload);
  }
};
export default browserLocation;